export default __webpack_public_path__ + "static/media/Pen.b1ca3d9a.svg";